import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type = 'website' }) => {
  const baseUrl = 'https://morningsandeyteer.com';

  // Website Schema
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Morning Sunday Teer Result",
    "url": baseUrl,
    "description": "Check Morning Sunday Teer Result Today with latest FR and SR results, previous results and Shillong Morning Teer updates.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${baseUrl}/?s={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  };

  // Organization Schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Morning Sunday Teer Result",
    "url": baseUrl,
    "logo": `${baseUrl}/favicon.svg`,
    "description": "Independent informational website providing Morning Sunday Teer results and updates.",
    "sameAs": []
  };

  // Breadcrumb Schema for subpages
  const breadcrumbSchemas = {
    'previous-results': {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": baseUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Previous Results",
          "item": `${baseUrl}/previous-results`
        }
      ]
    },
    'common-numbers': {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": baseUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Common Numbers",
          "item": `${baseUrl}/common-numbers`
        }
      ]
    },
    'house-target': {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": baseUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "House Target",
          "item": `${baseUrl}/house-target`
        }
      ]
    },
    'dream-number': {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": baseUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Dream Number",
          "item": `${baseUrl}/dream-number`
        }
      ]
    }
  };

  return (
    <Helmet>
      {/* Website Schema - Always include */}
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>

      {/* Organization Schema - Always include */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

      {/* Breadcrumb Schema - Include for subpages */}
      {type !== 'website' && breadcrumbSchemas[type] && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchemas[type])}
        </script>
      )}
    </Helmet>
  );
};

export default StructuredData;
